<template>
  <header v-header-anim :class="['header', DONT_MOVE]">
    <div class="header__container">
      <div class="header__inner">
        <div></div>
<!--        <VIcon class="logo logo&#45;&#45;header" width="122" height="34" icon-name="Logo" @click="goMain" />-->
        <TheNav />
      </div>
    </div>
  </header>
</template>

<script>
import VIcon from '@/components/ui/icon/VIcon'
import TheNav from '@/components/header/TheNav'
import { goMain } from '@/utils/goRoute'
import { headerAnim, DONT_MOVE } from '@/directives/anim.header'

export default {
  directives: {
    headerAnim,
  },
  components: {
    VIcon,
    TheNav,
  },
  setup() {
    return {
      DONT_MOVE,
      goMain,
    }
  },
}
</script>

